import React from 'react';
import { t } from '../../../modules/infra/i18n';

const NoLoansFound = () => (
  <div className="c-heading c-heading--small u-mt" data-automation-id="no-loans-found">
    {t('loans:no_loans_found')}
  </div>
);

export default NoLoansFound;

